import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProgressBar extends Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        bgColor: PropTypes.string,
        progress: PropTypes.number,
    };

    render() {
        const { bgColor, progress } = this.props;

        const containerStyles = {
            height: 20,
            width: '100%',
            backgroundColor: '#e0e0de',
            borderRadius: 50,
            marginTop: 8,
        };

        const fillerStyles = {
            height: '100%',
            width: `${progress}%`,
            backgroundColor: bgColor,
            borderRadius: 'inherit',
            textAlign: 'right',
        };

        const labelStyles = {
            padding: 5,
            color: 'white',
            fontWeight: 'bold',
        };

        return (
            <div className="progress-bar" style={containerStyles}>
                <div style={fillerStyles}>
                    <span style={labelStyles}>{progress}%</span>
                </div>
            </div>
        );
    }
}
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/Progressbar/Progressbar.js